import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link } from "react-router-dom";

// actions
import { userCreate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const UserCreate = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/users");
  };

  const [formData, setFormData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    group: "Gerencia",
    password: "",
    confirm_password: "",
  });

  const {
    username,
    first_name,
    last_name,
    email,
    phone_number,
    group,
    password,
    confirm_password,
  } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(userCreate(formData));
  };

  return (
    <div className="page-content">
      <MetaTags>
        <title>Carnesvilla | Usuarios </title>
      </MetaTags>
      <Container fluid>
        {/* Render Breadcrumb */}
        <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Usuarios"} />
        {props.loading ? (
          <Loader />
        ) : (
          <div className="d-flex justify-content-center">
            {props.userCreated.id ? (
              <SweetAlert
                title="¡Hecho!"
                success
                showConfirm={true}
                onConfirm={() => {
                  redirect();
                }}
              >
                El usuario <b>{props.userCreated.username}</b> se ha agregado
                correctamente.
              </SweetAlert>
            ) : null}
            <Card
              style={{
                width: "70rem",
              }}
            >
              <CardTitle className="ps-3 pt-3">
                <h2 className="mb-3 font-size-20">Nuevo usuario</h2>
              </CardTitle>
              <CardBody>
                <Form onSubmit={onSubmit}>
                  <Row className="justify-content-md-center">
                    <Col lg={8}>
                      <p>Datos personales</p>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={4}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-id-card bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Nombres"
                            name="first_name"
                            id="first_name"
                            value={first_name}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.first_name
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.first_name}
                          </FormFeedback>
                          <Label for="firstname">Nombres</Label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-id-card bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Apellidos"
                            name="last_name"
                            id="last_name"
                            value={last_name}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.last_name
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.last_name}
                          </FormFeedback>
                          <Label for="lastname">Apellidos</Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={4}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-envelope bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="email"
                            className="form-control"
                            placeholder="Email"
                            name="email"
                            id="email"
                            value={email}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.email
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.email}
                          </FormFeedback>
                          <Label for="email">Email</Label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-phone bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="tel"
                            className="form-control"
                            placeholder="Teléfono"
                            name="phone_number"
                            id="phone_number"
                            value={phone_number}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.phone_number
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.phone_number}
                          </FormFeedback>
                          <Label for="phone_number">Teléfono</Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={8}>
                      <hr></hr>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={8}>
                      <p>Datos de la cuenta</p>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={5}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-user-circle bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Usuario"
                            name="username"
                            id="username"
                            value={username}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.username
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.username}
                          </FormFeedback>
                          <Label for="username">Usuario</Label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="form-floating mb-3">
                        <select
                          className="form-select"
                          id="group"
                          name="group"
                          value={group}
                          onChange={onChange}
                        >
                          <option value="Gerencia">Gerencia</option>
                          <option value="Recaudo">Recaudo</option>
                          <option value="Veterinario">Veterinario</option>
                        </select>
                        <Label for="group">Rol</Label>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={4}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-lock-alt bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="password"
                            className="form-control"
                            placeholder="Contraseña"
                            name="password"
                            id="password"
                            value={password}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.password
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.password}
                          </FormFeedback>
                          <Label for="password">Contraseña</Label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="bx bx-lock-alt bx-sm" />
                        </span>
                        <div className="form-floating">
                          <Input
                            type="password"
                            className="form-control"
                            placeholder="Confirmar contraseña"
                            name="confirm_password"
                            id="confirm_password"
                            value={confirm_password}
                            onChange={onChange}
                            {...(props.error && {
                              ...(props.error.confirm_password
                                ? { invalid: true }
                                : { valid: true }),
                            })}
                            required
                          />
                          <FormFeedback tooltip>
                            {props.error.confirm_password}
                          </FormFeedback>
                          <Label for="confirm_password">
                            Confirmar contraseña
                          </Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mt-4 ms-5">
                    <Col lg={3}>
                      <Link className="btn btn-danger me-4" to="/users">
                        Cancelar
                      </Link>

                      <Button color="success" type="submit">
                        Crear
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </div>
        )}
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, userCreated } = state.User;
  return { error, loading, userCreated };
};

export default withRouter(connect(mapStateToProps)(UserCreate));
